import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  CreateAndUpdateWidgetsDTO,
  CreateWidgetsDTO,
  UpdateSingleWidgetDTO,
  UpdateWidgetsDTO,
} from "../../models/Widgets";
import {
  DeleteWidgetQuery,
  PageStoriesQuery,
  ProjectSuggestionsQuery,
  WidgetsSuggestionsQuery,
} from "../../api/widgets";

const initialState = {
  aiSuggestions: null,
  aiKpis: null,
};

const widgetsSlice = createSlice({
  name: "widgets",
  initialState,
  reducers: {
    requestCreateWidgets: (
      state,
      action: PayloadAction<CreateWidgetsDTO>
    ) => {},

    requestCreateWidgetSection: (
      state,
      action: PayloadAction<CreateWidgetsDTO>
    ) => {},

    requestWidgetsSuggestions: (
      state,
      action: PayloadAction<WidgetsSuggestionsQuery>
    ) => {},

    requestPageStories: (state, action: PayloadAction<PageStoriesQuery>) => {},
    requestPageBanner: (state, action: PayloadAction<PageStoriesQuery>) => {},

    requestProjectSuggestions: (
      state,
      action: PayloadAction<ProjectSuggestionsQuery>
    ) => {},

    setStorytellingSuggestions: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        storytellingSuggestions: action.payload,
      };
    },

    setAiKpis: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        aiKpis: action.payload,
      };
    },

    setAiBannerImage: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        aiBannerImage: action.payload,
      };
    },

    setAiSuggestions: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        aiSuggestions: action.payload,
      };
    },

    requestDeleteWidget: (state, action: PayloadAction<string>) => {},
    requestDeleteWidgetWithCallback: (state, action: PayloadAction<DeleteWidgetQuery>) => {},

    requestUpdateWidgets: (
      state,
      action: PayloadAction<UpdateWidgetsDTO>
    ) => {},

    requestCreateAndUpdateWidgets: (
      state,
      action: PayloadAction<CreateAndUpdateWidgetsDTO>
    ) => {},

    requestUpdateWidget: (
      state,
      action: PayloadAction<UpdateSingleWidgetDTO>
    ) => {},
  },
});

export const {
  requestWidgetsSuggestions,
  requestProjectSuggestions,
  setAiSuggestions,
  setStorytellingSuggestions,
  setAiBannerImage,
  requestCreateWidgets,
  requestUpdateWidgets,
  requestUpdateWidget,
  requestDeleteWidget,
  requestDeleteWidgetWithCallback,
  requestCreateWidgetSection,
  requestPageStories,
  requestPageBanner,
  requestCreateAndUpdateWidgets,
  setAiKpis,
} = widgetsSlice.actions;

export default widgetsSlice.reducer;
